import { isClientSide } from "@helper/utils";
import { fetchPuzzleData } from "@modules/WordPuzzle/server/fetchPuzzleData";
import { useEffect, useState } from "react";

export const usePuzzleData = (puzzleDate: string) => {
  const [questions, setQuestions] = useState<{ [key: string]: string }[]>([]);

  useEffect(() => {
    if (!isClientSide) return;
    const loadPuzzleData = () => {
      fetchPuzzleData(puzzleDate)
        .then((data) => {
          if (data && data.length > 0) {
            setQuestions(data);
          }
        })
        .catch(() => {
          console.error(`No data found for date: ${puzzleDate}`);
        });
    };
    loadPuzzleData();
  }, [puzzleDate]);

  return { questions };
};
